import { render, staticRenderFns } from "./package_cost.vue?vue&type=template&id=72672630&scoped=true&"
import script from "./package_cost.vue?vue&type=script&lang=js&"
export * from "./package_cost.vue?vue&type=script&lang=js&"
import style0 from "./package_cost.vue?vue&type=style&index=0&id=72672630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72672630",
  null
  
)

export default component.exports